<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12" md="12" sm="12">
          <v-text-field
            label="Full Names"
            v-model="name"
            :rules="nameRules"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="12" sm="12">
          <v-text-field label="ID Number" v-model="idNumber"></v-text-field>
        </v-col>
      </v-row>
    </v-container>
    <v-btn
      rounded
      small
      outlined
      class="mb-4 mx-4"
      :color="getOutlineColor"
      @click="addStaff()"
      dark
    >
      <v-icon left>mdi-plus</v-icon>Add Staff
    </v-btn>
  </div>
</template>

<script>
import axios from "@/plugins/axios";

export default {
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getOutlineColor() {
      return this.$store.getters.getOutlineColor;
    },
  },
  data: () => ({
    name: null,
    idNumber: null,
    nameRules: [(v) => !!v || "Field is required"],
  }),
  methods: {
    addStaff() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/add-employee",
          { name: this.name, idNumber: this.idNumber },
          this.getAccessToken
        )
        .then((employee) => {
          this.$store.commit("setLoader", false);
          this.$emit("staff-created", employee);
        });
    },
  },
};
</script>

<style></style>
